import request from 'superagent';

export default class PeaksLoader {
  constructor() {
    this.pending = false;
    this.aborted = false;
    this.request = null;
  }

  abort() {
    this.aborted = true;
    if (this.request) {
      this.request.abort();
    }
    this.pending = false;
    this.request = null;
  }

  load(url, callback) {
    if (this.pending) {
      throw new Error('Cannot .load() a pending loader');
    }

    if (this.aborted) {
      throw new Error('Cannot .load() an aborted loader');
    }

    this.pending = true;
    this.request = request
      .get(url)
      .responseType('arraybuffer')
      .end((err, res) => {
        if (!this.aborted) {
          this.pending = false;
          if (err) {
            callback(err);
          } else if (!res.ok) {
            callback(new Error(`Request completed with status ${res.statusCode}`));
          } else if (!(res.body instanceof ArrayBuffer)) {
            callback(new Error('Request completed without a valid body'));
          } else {
            callback(null, res.body);
          }
        }
      });
  }
}
